import { makeStyles } from '@mui/styles'
import PageData from '@v4/utils/data/PageData'

const useStyles = makeStyles(
	theme => {
		const isWhite = ({ white, pageType }, withShadow = false) => {
			if (withShadow && PageData.isTypeResultPdf(pageType)) {
				return false
			}
			return white === true || (white === 'theme' && theme.palette.whiteText)
		}

		const textShadowFrom = (props, withShadow) =>
			isWhite(props, withShadow) || props.shadow ? '0 0 4px rgb(0 0 0 / 40%)' : null

		return {
			root: {
				width: '100%',
				color: props =>
					isWhite(props)
						? '#FFFFFF'
						: theme.palette.calcContrastColor(
								theme.palette.scoreapp.primary,
								props.usePaperColors
									? theme.palette.background.paper
									: theme.palette.background.default,
						  ),
				display: 'flex',
				alignItems: 'center',
				textTransform: 'uppercase',
				position: 'relative',
				zIndex: 1,
				'&:before, &:after': {
					content: '""',
					display: 'block',
					width: 1,
					flexGrow: 1,
					borderBottom: '1px dashed currentColor',
				},
			},
			icon: {},
			button: {
				color: 'inherit',
				flexShrink: 0,
				fontFamily: 'Instrument Sans',
				padding: theme.spacing(0.5, 1.5),
				fontSize: theme.spacing(1.5),
				margin: theme.spacing(0, 1.5),
				maxWidth: `calc(100% - ${theme.spacing(3)})`,
				fontWeight: 500,
				textShadow: props => textShadowFrom(props, true),
				background: 'transparent !important',
				border: '1px solid transparent',
				transition: theme.transitions.create(['border-color']),
				'&:hover': {
					borderColor: 'currentColor',
				},
				'& $icon': {
					marginRight: 2,
					'& svg': {
						fontSize: theme.spacing(1.5),
					},
				},
			},
		}
	},
	{ name: 'EditableContainer' },
)

export default useStyles
